<template>
    <div class="mine-page">
        <section class="mine-hero">
            <div class="mine-hero__copy">
                <SplitText
                    className="mine-hero__title"
                    :text="$t('mining.title')"
                    textAlign="left"
                    splitType="chars"
                    :delay="35"
                    :duration="0.45"
                    rootMargin="0px"
                />
                <p>{{ $t('mining.subtitle') }}</p>
            </div>
            <img class="mine-hero__coin" src="@/assets/img/home/card-output.png" alt="">
        </section>

        <AnimatedContent className="mine-stats" :distance="32" :duration="0.7" :delay="0.08">
            
            <div class="mine-stats__row mine-stats__row--top">
                <div  class="mine-stats__item">
                    <div class="mine-stats__label">
                        <img src="@/assets/img/mining/icon-total.png" alt="">
                        <span>{{ $t('mining.totalT') }}</span>
                    </div>
                    <div class="mine-stats__value">
                        <NumberScroll :to="totalMing" :decimal="true" :decimal-digits="2" :duration="1.5" />
                    </div>
                </div>
           

          
                <div  class="mine-stats__item">
                    <div class="mine-stats__label">
                        <img src="@/assets/img/mining/icon-share.png" alt="">
                        <span>{{ $t('mining.shareT') }}</span>
                    </div>
                    <div class="mine-stats__value">
                        <NumberScroll :to="shareMing" :decimal="true" :decimal-digits="2" :duration="1.5" />
                    </div>
                </div>
          

           
                <div  class="mine-stats__item">
                    <div class="mine-stats__label">
                        <img src="@/assets/img/mining/icon-team.png" alt="">
                        <span>{{ $t('mining.teamT') }}</span>
                    </div>
                    <div class="mine-stats__value">
                        <NumberScroll :to="teamMing" :decimal="true" :decimal-digits="2" :duration="1.5" />
                    </div>
                </div>
            </div>



            <div class="mine-stats__row mine-stats__row--bottom">
                <div  class="mine-stats__item">
                    <div class="mine-stats__label">
                        <img src="@/assets/img/mining/icon-burn.png" alt="">
                        <span>{{ $t('mining.burnT') }}</span>
                    </div>
                    <div class="mine-stats__value">
                        <NumberScroll :to="burnMing" :decimal="true" :decimal-digits="2" :duration="1.5" />
                    </div>
                </div>

                <div  class="mine-stats__item">
                    <div class="mine-stats__label">
                        <img src="@/assets/img/mining/icon-valid.png" alt="">
                        <span>{{ $t('mining.validBurnT') }}</span>
                    </div>
                    <div class="mine-stats__value">
                        <NumberScroll :to="useMing" :decimal="true" :decimal-digits="2" :duration="1.5" />
                    </div>
                </div>

                <StarBorder as="div" customClass="star-cta star-cta--renew" color="#FFE566" speed="4s" :thickness="0">
                    <button class="mine-stats__renew" type="button" @click="renewShow = true">{{ $t('mining.renew') }}</button>
                </StarBorder>
            </div>
        </AnimatedContent>

        <AnimatedContent :distance="28" :duration="0.7" :delay="0.1">
            <section class="mine-card">
                <h2>{{ $t('mining.title') }}</h2>
                <img class="mine-card__flame" src="@/assets/img/mining/card-flame.png" alt="">
                <div class="mine-input">
                    <input v-model="amount" :placeholder="$t('mining.amountPlaceholder')">
                    <span>T</span>
                </div>
                <div class="mine-label">{{ $t('mining.token') }}</div>
                <div
                    class="mine-token"
                    @touchstart.passive="onTokenTouchStart"
                    @touchend="onTokenTouchEnd"
                >
                    <span class="mine-token__slider" :class="{ right: token === 'USDT' }"></span>
                    <button type="button" :class="{ active: token === 'DOL' }" @click="selectToken('DOL')">
                        <img src="@/assets/img/mining/token-fovo.png" alt="">
                        DOL
                    </button>
                    <button type="button" :class="{ active: token === 'USDT' }" @click="selectToken('USDT')">
                        <img src="@/assets/img/mining/token-usdt.png" alt="">
                        USDT
                    </button>
                </div>
                <div class="mine-row">
                    <span>
                        <img src="@/assets/img/mining/icon-rate.png" alt="">
                        {{ $t('mining.rate') }}
                    </span>
                    <!-- <strong>1T =100U= {{100/dolPrice}} DOL</strong> -->
                    <strong>{{returnStrong}} </strong>
                </div>
                <div class="mine-row mine-row--balance">
                    <span>
                        <img src="@/assets/img/mining/icon-wallet.svg" alt="">
                        {{ $t('mining.balance') }}
                    </span>
                    <div>
                        
                        <p v-if="token=='DOL'">{{dolAmount}} <em>DOL</em></p>
                        <p v-else>{{usdtAmount}} <em>USDT</em></p>
                    </div>
                </div>
                <StarBorder as="div" customClass="star-cta star-cta--submit" color="#FFE566" speed="4s" :thickness="0">
                    <button class="mine-btn" type="button" @click="doMining()">{{ $t('mining.submit') }}</button>
                </StarBorder>
                <p class="mine-hint">
                    <!-- <img src="@/assets/img/mining/icon-hint-flame.png" alt=""> -->
                    <!-- {{ $t('mining.hint') }} -->
                </p>
            </section>
        </AnimatedContent>

        <FadeContent :blur="false" :delay="60" :duration="800">
            <section class="mine-card mine-record">
                <div class="mine-tabs">
                    <span
                        v-for="tab in tabs"
                        :key="tab"
                        :class="{ active: recordTab === tab }"
                        @click="recordTab = tab"
                    >{{ $t('mining.' + tab) }}</span>
                </div>

                <template v-if ="recordTab =='burnLog'">

                <FadeContent
                    v-for="(item, index) in list1"
                    :key="item.ID"
                    :delay="80 * index"
                    :duration="500"
                >
                    <div class="mine-record__item" :class="{ 'is-split': index > 0 }">
                        <div class="mine-record__top">
                            <span>
                                <img src="@/assets/img/mining/icon-clock.png" alt="">
                                <span> {{ item.AddTime }}</span>
                            </span>
                            <em class="ok">{{ $t('mining.success')  }}</em>
                        </div>
                        <div class="mine-record__nums">
                            <div>
                                <label>{{ $t('mining.qty') }}<i>({{ item.DS }})</i></label>
                                <strong>
                                    <NumberScroll :to="Number(item.Amount)" :decimal="true" :decimal-digits="1" :duration="1.2" />
                                </strong>
                            </div>
                            <div class="mine-record__hash">
                                <label>{{ $t('mining.hashrateT') }}<i>(T)</i></label>
                                <strong>
                                    <NumberScroll :to="Number(item.AAmount)" :decimal="true" :decimal-digits="2" :duration="1.2" />
                                </strong>
                            </div>
                        </div>
                    </div>
                </FadeContent>
                </template>

                <template v-else-if ="recordTab =='shareLog'">

                <FadeContent
                    v-for="(item, index) in list2"
                    :key="item.ID"
                    :delay="80 * index"
                    :duration="500"
                >
                    <div class="earn-wd" :class="{ 'is-split': index > 0 }">
                            <div class="earn-wd__top">
                                <div class="earn-wd__meta">
                                    <p class="earn-wd__time">
                                        <img src="@/assets/img/mining/icon-clock.png" alt="">
                                        {{item.AddTime}}
                                    </p>
                                    <p class="earn-wd__addr">
                                        <img src="@/assets/img/earnings/icon-addr-wallet.png" alt="">
                                        {{item.addr}}({{item.loads}})
                                    </p>
                                </div>
                            </div>
                            <div class="earn-wd__nums">
                                <div>
                                    <label>{{$t('mining.burnT') }}<em>(T)</em></label>
                                    <strong>
                                        {{item.Amount}}
                                    </strong>
                                </div>
                                <div class="earn-wd__nums-right">
                                    <label>{{ $t('mining.ext1')  }} <em>(T)</em></label>
                                    <strong>
                                        {{item.RewardAmount}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                </FadeContent>
                </template>
                <template v-else-if ="recordTab =='renewLog'">

                <FadeContent
                    v-for="(item, index) in list3"
                    :key="item.ID"
                    :delay="80 * index"
                    :duration="500"
                >
                    <div class="earn-wd" :class="{ 'is-split': index > 0 }">
                            <div class="earn-wd__top">
                                <div class="earn-wd__meta">
                                    <p class="earn-wd__time">
                                        <img src="@/assets/img/mining/icon-clock.png" alt="">
                                        {{item.AddTime}}
                                    </p>
                                </div>
                            </div>
                            <div class="earn-wd__nums">
                                <div>
                                    <label>{{ $t('mining.ext2')  }}<em>(DOL)</em></label>
                                    <strong>
                                        {{item.skAmount}}
                                    </strong>
                                </div>
                                <div class="earn-wd__nums-right">
                                    <label>{{ $t('mining.ext3') }} <em>(DOL)</em></label>
                                    <strong>
                                        {{item.dolAmount}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                </FadeContent>
                </template>

            </section>
        </FadeContent>

        <Popup v-model="renewShow" round get-container="#app" class="mine-renew-popup">
            <div class="mine-renew">
                <div class="mine-renew__head">
                    <h3>{{ $t('mining.renew') }}</h3>
                    <button type="button" @click="renewShow = false">
                        <img src="@/assets/img/mining/icon-close.png" alt="">
                    </button>
                </div>
                <div class="mine-renew__stats">
                    <div class="mine-renew__stat">
                        <p>{{ $t('mining.renewHashrate') }}<em>(DOL)</em></p>
                        <strong>{{minginMonthAmount}}</strong>
                    </div>
                    <div class="mine-renew__stat">
                        <p>{{ $t('mining.renewFee') }}<em>(DOL)</em></p>
                        <strong>{{minginMonthAmount/10}}</strong>
                    </div>
                </div>
                <div class="mine-renew__row">
                    <span>
                        <img src="@/assets/img/mining/icon-date.png" alt="">
                        {{ $t('mining.renewDate') }}
                    </span>
                    <b>{{dateToDate}}</b>
                </div>
                <!-- <div class="mine-renew__row">
                    <span>
                        <img src="@/assets/img/mining/icon-convert.svg" alt="">
                        {{ $t('mining.renewConvert') }}
                    </span>
                    <b>230343.23 <em>FOVO</em></b>
                </div> -->
                <div class="mine-renew__row">
                    <span>
                        <img src="@/assets/img/mining/icon-wallet-row.png" alt="">
                        {{ $t('mining.balance') }}
                    </span>
                    <b>{{dolAmount}} <em>DOL</em></b>
                </div>
                <div class="mine-renew__row mine-renew__row--note">
                    <span>
                        <img src="@/assets/img/mining/icon-info.png" alt="">
                       2026-11-03 
                    </span>
                    <b>{{ $t('mining.renewNoteText') }}</b>
                </div>
                <button class="mine-renew__btn" type="button" @click="DOrenew()">
                    {{ $t('mining.renewConfirm') }}
                </button>
            </div>
        </Popup>
    </div>
</template>

<script>
import { Popup } from 'vant';
import AnimatedContent from '@/components/AnimatedContent/AnimatedContent.vue';
import FadeContent from '@/components/FadeContent/FadeContent.vue';
import SplitText from '@/components/SplitText/SplitText.vue';
import NumberScroll from '@/components/NumberScroll.vue';
import StarBorder from '@/components/StarBorder/StarBorder.vue';



import axios from 'axios'
import contractaa from '../contract/index.js';

import Web3 from 'web3'
let web3
web3 = new Web3(window.ethereum);

export default {
    name: 'mining-page',
    components: { Popup, AnimatedContent, FadeContent, SplitText, NumberScroll, StarBorder },
    data() {
        return {
            amount: '',
            token: 'USDT',
            tokenTouchX: null,
            renewShow: false,
            recordTab: 'burnLog',
            records: [
                { id: 1, time: '2026-09-28 15:37:01', ok: true, unit: 'USDT', qty: '125.9', hashrate: '100.22' },
                { id: 2, time: '2026-09-28 15:37:01', ok: false, unit: 'USDT', qty: '125.9', hashrate: '100.22' },
                { id: 3, time: '2026-09-28 15:37:01', ok: false, unit: 'ABC', qty: '125.9', hashrate: '100.22' },
            ],
            recordsT: [
                { id: 1, time: '2026-09-29 15:37:01', ok: true, unit: 'USDT', qty: '125.9', hashrate: '100.22' },
                { id: 2, time: '2026-09-29 15:37:01', ok: false, unit: 'USDT', qty: '125.9', hashrate: '100.22' },
                { id: 3, time: '2026-09-29 15:37:01', ok: false, unit: 'ABC', qty: '125.9', hashrate: '100.22' },
            ],
            recordsTH: [
                { id: 1, time: '2026-09-30 15:37:01', ok: true, unit: 'USDT', qty: '125.9', hashrate: '100.22' },
                { id: 2, time: '2026-09-30 15:37:01', ok: false, unit: 'USDT', qty: '125.9', hashrate: '100.22' },
                { id: 3, time: '2026-09-30 15:37:01', ok: false, unit: 'ABC', qty: '125.9', hashrate: '100.22' },
            ],
            burnMing:0,
            shareMing:0,
            teamMing:0,
            useMing:0,
            totalMing:0,
            dolPrice:0,
            usdtAmount:0,
            dolAmount:0,
            minginMonthAmount:0,
            doMiningDate:'',
            doRe:'',
            list1:[],
            list2:[],
            list3:[],
        };
    },
    computed: {
      
        tabs() {
            return ['burnLog', 'shareLog', 'renewLog'];
        },
        returnStrong(){
            let _power = this.amount || 1
            let _usdt = _power *100
            let _dol = _usdt/this.dolPrice
            return ''+_power+'T ='+_usdt+'U= '+_dol+' DOL'
        },
        dateToDate(){
            if(this.doMiningDate==''){
                return ''
            }else if(this.doMiningDate !='' && this.doRe==''){
                return this.doMiningDate.slice(0,10) +' - '+this.getMonthLastDay(this.doMiningDate)
            }else{
                return ''
            }
        }
    },
    methods: {
        getMonthLastDay(dateStr) {
        const date = new Date(dateStr);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        return `${lastDay.getFullYear()}-${String(lastDay.getMonth() + 1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`;
        },
        selectToken(token) {
            this.token = token;
        },
        onTokenTouchStart(e) {
            this.tokenTouchX = e.changedTouches[0].clientX;
        },
        onTokenTouchEnd(e) {
            if (this.tokenTouchX == null) {
                return;
            }
            const dx = e.changedTouches[0].clientX - this.tokenTouchX;
            this.tokenTouchX = null;
            if (dx > 28) {
                this.selectToken('DOL');
            } else if (dx < -28) {
                this.selectToken('USDT');
            }
        },
        //续期按钮
        async DOrenew(){
            let that = this
            let useraddr = this.$store.state.globalAddress

            that.$toast.success('未到续约时间')
            that.renewShow = false
        },
        //参与燃烧按钮
        async doMining(){
            let that = this
            let useraddr = this.$store.state.globalAddress
            that.$store.commit('handleShow', true)
            let vstr="user_power"
            let vsign = await ethereum.request({method: "personal_sign",params: [vstr, useraddr]});
            let _t = 1
            if(that.token =="DOL"){
                _t  = 2
            }
            let result = await axios.post(contractaa.APIURL+'?cmd=addburn',"addr="+useraddr+"&singer="+vsign+"&amount="+that.amount+"&t="+_t)
            if(result.data.Status){
                that.$store.commit('handleShow', false)  
                that.$toast.success(that.$t('layout.success'))

            }else{
                //that.$toast.fail(that.$t('layout.failed'))
                that.$toast.fail(result.data.Message)
                that.$store.commit('handleShow', false)  
            }
           
            that.getInfo()
        },
        async getInfo(){
            let that = this
            let useraddr = this.$store.state.globalAddress
            let axiosResult = await axios.post(contractaa.APIURL+'?cmd=burn','addr='+useraddr);
            if(axiosResult.status == 200){
                if(axiosResult.data.Status){
                    let _arr = axiosResult.data.Message.split('|')

                    that.burnMing = Number(_arr[0])
                    that.shareMing = Number(_arr[1])
                    that.teamMing = Number(_arr[2])
                    that.useMing = Number(_arr[3])
                    that.dolPrice = Number(_arr[4])
                    that.usdtAmount = Number(_arr[5])
                    that.dolAmount = Number(_arr[6])
                    that.totalMing = that.burnMing + that.shareMing +that.teamMing
                    //that.list = axiosResult.data.Data

                    that.doMiningDate = _arr[7]
                    that.doRe = _arr[8]
                    that.minginMonthAmount = Number(_arr[9])
                }
            }
            let axiosBurnResult = await axios.post(contractaa.APIURL+'?cmd=burnlist','page=1&addr='+useraddr);
            if(axiosBurnResult.status == 200){
                if(axiosBurnResult.data.Status){
                    that.list1 = axiosBurnResult.data.Data
                }
            }

            let axiosShareResult = await axios.post(contractaa.APIURL+'?cmd=sharepowerlist','page=1&addr='+useraddr);
            if(axiosShareResult.status == 200){
                if(axiosShareResult.data.Status){
                    that.list2 = axiosShareResult.data.Data
                }
            }

            let axiosReResult = await axios.post(contractaa.APIURL+'?cmd=relist','page=1&addr='+useraddr);
            if(axiosReResult.status == 200){
                if(axiosReResult.data.Status){
                    that.list3 = axiosReResult.data.Data
                }
            }

        }
    },
    mounted(){
        this.getInfo()
    }
};
</script>

<style lang="less" scoped>
.mine-page {
    padding: 0 0 12px;
    color: #101126;
}

.mine-hero {
    position: relative;
    z-index: 0;
    height: 194px;
    padding: 29px 16px 0;
    overflow: hidden;
    background: linear-gradient(120deg, #FFE56A 0%, #F5C400 55%, #FFF1A0 100%);

    h1, .mine-hero__title {
        font-size: 26px;
        font-weight: 700;
        line-height: 36px;
    }

    p {
        margin-top: 4px;
        font-size: 14px;
        line-height: 20px;
        opacity: 0.5;
    }

    &__coin {
        position: absolute;
        right: -24px;
        top: 0;
        width: 220px;
        height: 194px;
        object-fit: cover;
        pointer-events: none;
    }
}

.mine-stats {
    position: relative;
    z-index: 2;
    margin: -75px 16px 0;

    &__row {
        width: 343px;
        height: 77px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        background: #FFFFFF;
    }

    &__row--top {
        border-radius: 14px 14px 0 0;
    }

    &__row--bottom {
        border-radius: 0 0 14px 14px;
    }

    &__item {
        flex: 1;
        text-align: left;
    }

    &__label {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        line-height: 18px;
        color: rgba(16, 17, 38, 0.7);

        img {
            width: 18px;
            height: 18px;
            flex-shrink: 0;
        }
    }

    &__value {
        margin-top: 5px;
        font-family: DINAlternate-Bold, sans-serif;
        font-size: 24px;
        line-height: 24px;
        font-weight: 700;
    }

    &__renew {
        width: 75px;
        height: 40px;
        flex-shrink: 0;
        border: 0;
        border-radius: 10px;
        background-image: linear-gradient(-57deg, #FEC612 0%, #FFEC47 45%, #FED937 100%);
        font-size: 14px;
        font-weight: 500;
        color: #101126;
    }
}
.earn-wd {
    padding: 0 0 10px;

    &.is-split {
        padding-top: 10px;
        border-top: 0.5px solid #E3E3E3;
    }

    &__top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 8px;
    }

    &__time {
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        line-height: 12px;
        color: rgba(16, 17, 38, 0.5);

        img {
            width: 10px;
            height: 10px;
            object-fit: contain;
        }
    }

    &__addr {
        margin-top: 9px;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        line-height: 12px;
        white-space: nowrap;

        img {
            width: 10px;
            height: 10px;
            flex-shrink: 0;
            object-fit: contain;
        }
    }

    &__status {
        flex-shrink: 0;
        height: 22px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        font-style: normal;
        font-size: 13px;
        font-weight: 500;
        border-radius: 13px;

        &.success {
            color: #048C4D;
            background: #E5FAEC;
        }

        &.pending {
            color: #FE7F18;
            background: #FEF2E0;
        }

        &.fail {
            color: #E54712;
            background: #FAE7E5;
        }
    }

    &__nums {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;

        label {
            display: block;
            font-size: 12px;
            line-height: 12px;
            color: rgba(16, 17, 38, 0.7);

            em {
                font-style: normal;
                color: rgba(16, 17, 38, 0.5);
            }
        }

        strong {
            display: block;
            margin-top: 4px;
            font-size: 20px;
            line-height: 24px;
            font-family: DINAlternate-Bold, sans-serif;
        }

        &-right {
            text-align: right;
        }
    }
}
.mine-card {
    position: relative;
    margin: 10px 16px 0;
    width: 343px;
    padding: 15px;
    background: #FFFFFF;
    border-radius: 14px;

    h2 {
        position: relative;
        z-index: 1;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 12px;
    }

    &__flame {
        position: absolute;
        top: 15px;
        right: 14px;
        width: 64px;
        height: 41px;
        pointer-events: none;
        object-fit: contain;
    }
}

.mine-input {
    width: 313px;
    height: 50px;
    padding: 0 14px;
    display: flex;
    align-items: center;
    background: #FAFBFC;
    border: 1px solid #E3E3E3;
    border-radius: 10px;
    position: relative;
    z-index: 1;

    input {
        flex: 1;
        border: 0;
        outline: none;
        font-size: 14px;
        background: transparent;
    }

    span {
        font-size: 14px;
        color: #101126;
        font-weight: 500;
    }
}

.mine-label {
    margin: 14px 0 8px;
    font-size: 14px;
    opacity: 0.5;
    color: #101126;
}

.mine-token {
    position: relative;
    display: flex;
    width: 313px;
    height: 40px;
    background: rgba(252, 238, 153, 0.3);
    border-radius: 10px;
    overflow: hidden;
    user-select: none;

    &__slider {
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 40px;
        background: #FCEE99;
        border-radius: 10px;
        transition: transform 0.22s ease;
        pointer-events: none;

        &.right {
            transform: translateX(100%);
        }
    }

    button {
        position: relative;
        z-index: 1;
        flex: 1;
        height: 40px;
        padding: 0;
        border: 0;
        border-radius: 10px;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        font-size: 14px;
        font-weight: 500;
        color: #101126;
        line-height: 20px;

        img {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            object-fit: cover;
            flex-shrink: 0;
        }
    }
}

.mine-row {
    margin-top: 14px;
    width: 313px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 12px;

    span {
        display: flex;
        align-items: center;
        gap: 8px;
        color: rgba(16, 17, 38, 0.55);
        line-height: 18px;

        img {
            width: 18px;
            height: 18px;
            flex-shrink: 0;
        }
    }

    strong {
        line-height: 18px;
        font-weight: 500;
    }

    p {
        text-align: right;
        font-size: 12px;
        line-height: 12px;
        font-weight: 500;
        color: #101126;

        + p {
            margin-top: 10px;
        }

        em {
            font-style: normal;
            font-weight: 500;
            color: #575867;
        }
    }
}

.mine-btn {
    margin-top: 0;
    width: 313px;
    height: 40px;
    border: 0;
    border-radius: 10px;
    background-image: linear-gradient(-57deg, #FEC612 0%, #FFEC47 45%, #FED937 100%);
    font-size: 14px;
    font-weight: 500;
    color: #101126;
}

.mine-hint {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    color: #101126;

    img {
        width: 22px;
        height: 22px;
        display: block;
        flex-shrink: 0;
        object-fit: contain;
        transform: translateY(1px);
    }
}

.mine-tabs {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 8px;
    margin: 0 -15px 16px;
    padding: 0 15px;
    border-bottom: 0.5px solid #E3E3E3;

    span {
        position: relative;
        flex: 0 1 auto;
        font-size: 16px;
        line-height: 22px;
        font-weight: 400;
        color: #101126;
        opacity: 0.5;
        white-space: nowrap;
        padding-bottom: 11px;

        &.active {
            opacity: 1;
            font-weight: 600;

            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 3px;
                background: #101126;
                border-radius: 2px;
            }
        }
    }
}

.mine-record__item {
    padding: 0;

    &.is-split {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 0.5px solid #E3E3E3;
    }
}

.mine-record__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    line-height: 12px;

    span {
        display: flex;
        align-items: center;
        gap: 2px;
        color: #101126;

        img {
            width: 12px;
            height: 12px;
            object-fit: contain;
            margin-right: 4px;
        }
        span {
        opacity: 0.5;

        }
    }

    em {
        box-sizing: border-box;
        min-width: 50px;
        height: 22px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        border-radius: 13px;

        &.ok {
            color: #048C4D;
            background: #E5FAEC;
        }

        &.fail {
            color: #E54712;
            background: #FAE7E5;
        }
    }
}

.mine-record__nums {
    margin-top: 18px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    label {
        display: block;
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
        color: rgba(16, 17, 38, 0.7);

        i {
            margin-left: 4px;
            font-style: normal;
            color: rgba(16, 17, 38, 0.5);
        }
    }

    strong {
        display: block;
        margin-top: 4px;
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
        color: #101126;
        font-family: DINAlternate-Bold, sans-serif;
    }
}

.mine-record__hash {
    text-align: right;
}

/deep/ .star-cta--submit {
    width: 313px;
    margin-top: 16px;
}

/deep/ .star-cta--renew {
    width: 75px;
    flex-shrink: 0;
}

.mine-renew-popup {
    width: 302px;
    overflow: hidden;
    background: #FFFFFF;
    border-radius: 14px;
    padding: 0;
}

.mine-renew {
    width: 302px;
    padding: 14px 15px 20px;
    color: #101126;
    box-sizing: border-box;

    &__head {
        position: relative;
        height: 22px;
        margin-bottom: 19px;
        display: flex;
        align-items: center;
        justify-content: center;

        h3 {
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
        }

        button {
            position: absolute;
            right: 0;
            top: 3px;
            width: 16px;
            height: 16px;
            padding: 0;
            border: 0;
            background: transparent;
            line-height: 0;

            img {
                width: 16px;
                height: 16px;
            }
        }
    }

    &__stats {
        display: flex;
        width: 272px;
        height: 70px;
        background: rgba(252, 238, 153, 0.5);
        border-radius: 10px;
        margin-bottom: 11px;
    }

    &__stat {
        flex: 1;
        height: 70px;
        padding: 15px 0 0 16px;
        box-sizing: border-box;

        p {
            font-size: 12px;
            line-height: 12px;
            color: rgba(16, 17, 38, 0.7);

            em {
                margin-left: 4px;
                font-style: normal;
                color: rgba(16, 17, 38, 0.5);
            }
        }

        strong {
            display: block;
            margin-top: 4px;
            font-size: 20px;
            line-height: 24px;
            font-weight: 700;
            font-family: DINAlternate-Bold, sans-serif;
        }
    }

    &__row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        height: 40px;
        border-bottom: 0.5px solid #E3E3E3;

        span {
            display: flex;
            align-items: center;
            gap: 8px;
            flex-shrink: 0;
            font-size: 12px;
            line-height: 12px;
            color: rgba(16, 17, 38, 0.5);

            img {
                width: 18px;
                height: 18px;
                border-radius: 6px;
                flex-shrink: 0;
            }
        }

        b {
            font-size: 12px;
            line-height: 12px;
            font-weight: 500;
            text-align: right;
            color: #101126;

            em {
                font-style: normal;
                font-weight: 500;
                color: #575867;
            }
        }

        &--note {
            height: auto;
            min-height: 40px;
            margin-top: 15px;
            padding: 0;
            align-items: flex-start;
            border-bottom: 0;

            b {
                width: 185px;
                line-height: 18px;
                font-weight: 400;
            }
        }
    }

    &__btn {
        display: block;
        margin-top: 20px;
        width: 272px;
        height: 40px;
        border: 0;
        border-radius: 10px;
        background-image: linear-gradient(-57deg, #FEC612 0%, #FFEC47 45%, #FED937 100%);
        font-size: 14px;
        font-weight: 500;
        color: #101126;
    }
}
</style>
